import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";

const DriverKPI = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [totalHours, setTotalHours] = useState("");
  const [statesList, setStatesList] = useState([]);
  const [selState, setSelState] = useState("");
  const [startDate, setStartDate] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 2).toISOString(),
  );
  const [endDate, setEndDate] = useState(new Date().toISOString());

  const [totalReturn, settotalReturn] = useState("");
  const [totalGateIn, settotalGateIn] = useState("");
  const [totalWbHr, settotalWbHr] = useState("");
  const [totalOrder, settotalOrder] = useState("");
  const [totalLoadingHr, settotalLoadingHr] = useState("");
  const [totalHrsLoads, settotalHrsLoads] = useState("");

  const [totalWorkshopJobs, setTotalWorkshopJobs] = useState("");
  const [totalWorkshopHrs, setTotalWorkshopHrs] = useState("");
  const [totalHrsJob, setTotalHrsJob] = useState("");
  const [totalFuelLtrs, setTotalFuelLtrs] = useState("");
  const [totalKmCovered, setTotalKmCovered] = useState("");
  const [totalKmLtr, setTotalKmLtr] = useState("");
  const [totalMileageCost, setTotalMileageCost] = useState("");
  const [totalCost, setTotalCost] = useState("");
  const [totalCPK, setTotalCPK] = useState("");

  const [selDepartment, setSelDepartment] = useState("");
  const [departmentList, setDepartmentList] = useState([]);
  const [selMake, setSelMake] = useState("");
  const [makeList, setMakeList] = useState([]);

  const [selSortBy, setSelSortBy] = useState("");
  const [selOrderBy, setSelOrderBy] = useState("");

  const filteredData = vehiclesList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0 && !selDepartment && !selMake) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "DRIVERNAME",
        "DEPARMENT",
        "MAKE",
        "VEHICLE",
        "GATE INS",
        "RETURNS",
        "W/B HRS",
        "ORDERS",
        "LOADING HRS",
        "HRS/LOAD",
        "WORKSHOP JOBS",
        "WORKSHOP HRS",
        "HRS/JOB",
        "FUEL LTRS",
        "KM COVERED",
        "KM/LTR",
        "MILEAGE COST",
        "TOTAL COST",
        "CPK",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    const departmentFilter =
      !selDepartment || item?.DEPARMENT === selDepartment;
    const makeFilter = !selMake || item?.MAKE === selMake;

    return textMatch && departmentFilter && makeFilter;
  });

  const sortedData = [...filteredData].sort((a, b) => {
    if (!selSortBy) return 0;

    const valA = Number(a?.[selSortBy]) || 0;
    const valB = Number(b?.[selSortBy]) || 0;

    if (selOrderBy === "DESCENDING") {
      return valB - valA; // highest → lowest
    } else if (selOrderBy === "ASCENDING") {
      return valA - valB; // lowest → highest
    }

    return 0;
  });

  useEffect(() => {
    let totalReturns = 0;
    let totalGateIns = 0;
    let totalWbHrs = 0;
    let totalOrders = 0;
    let totalLoadingHrs = 0;
    let totalHrsLoad = 0;
    let totalWorkshopJob = 0;
    let totalWorkshopHr = 0;
    let totalHrsJobs = 0;
    let totalFuelLtr = 0;
    let totalKmCovereds = 0;
    let totalKmLtrs = 0;
    let totalMileageCosts = 0;
    let totalCosts = 0;
    let totalCPKs = 0;

    filteredData?.forEach((item) => {
      totalReturns += parseFloat(item?.RETURNS || 0);
      totalGateIns += parseFloat(item?.["GATE INS"] || 0);
      totalWbHrs += parseFloat(item?.["W/B HRS"] || 0);
      totalOrders += parseFloat(item?.ORDERS || 0);
      totalLoadingHrs += parseFloat(item?.["LOADING HRS"] || 0);
      totalHrsLoad += parseFloat(item?.["HRS/LOAD"] || 0);
      totalWorkshopJob += parseFloat(item?.["WORKSHOP JOBS"] || 0);
      totalWorkshopHr += parseFloat(item?.["WORKSHOP HRS"] || 0);
      totalHrsJobs += parseFloat(item?.["HRS/JOB"] || 0);
      totalFuelLtr += parseFloat(item?.["FUEL LTRS"] || 0);
      totalKmCovereds += parseFloat(item?.["KM COVERED"] || 0);
      totalKmLtrs += parseFloat(item?.["KM/LTR"] || 0);
      totalMileageCosts += parseFloat(item?.["MILEAGE COST"] || 0);
      totalCosts += parseFloat(item?.["TOTAL COST"] || 0);
      totalCPKs += parseFloat(item?.["CPK"] || 0);
    });

    settotalReturn(totalReturns);
    settotalGateIn(totalGateIns);
    settotalWbHr(totalWbHrs);
    settotalOrder(totalOrders);
    settotalLoadingHr(totalLoadingHrs);
    settotalHrsLoads(totalHrsLoad);
    setTotalWorkshopJobs(totalWorkshopJob);
    setTotalWorkshopHrs(totalWorkshopHr);
    setTotalHrsJob(totalHrsJobs);
    setTotalFuelLtrs(totalFuelLtr);
    setTotalKmCovered(totalKmCovereds);
    setTotalKmLtr(totalKmLtrs);
    setTotalMileageCost(totalMileageCosts);
    setTotalCost(totalCosts);
    setTotalCPK(totalCPKs);
  }, [filteredData]);

  useEffect(() => {
    initialData();
  }, [startDate, endDate]);

  const initialData = () => {
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandlerFunctionWithParamsFrom?viewname=1331&STARTDATE=${moment(
          startDate,
        ).format("YYYY/MM/DD")}&ENDDATE=${moment(endDate).format(
          "YYYY/MM/DD",
        )}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      )
      .then((response) => {
        setVehiclesList(response?.data);
        const departmentData = new Set(
          response?.data?.map((item) => item?.DEPARMENT).filter(Boolean),
        );
        setDepartmentList([...departmentData]);
        const makeData = new Set(
          response?.data?.map((item) => item?.MAKE).filter(Boolean),
        );
        setMakeList([...makeData]);
        setisloading(false);
      })
      .catch((err) => {
        console.log("Error While fetching 1331", err);
        setisloading(false);
      });
  };

  // ***************** EXPORT TO PDF AND EXCEL **********************
  const ExcelStockData = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Vehicles KPI");
    const rows = document.querySelectorAll(".table_1 tbody tr");

    const columnWidths = [
      20, 15, 15, 25, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10,
      10,
    ];

    // Set column widths for the worksheet
    columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    // Add headers
    const headerRow = worksheet.addRow([
      "S NO",
      "DRIVERNAME",
      "DEPARMENT",
      "MAKE",
      "VEHICLE",
      "GATE INS",
      "RETURNS",
      "W/B HRS",
      "ORDERS",
      "LOADING HRS",
      "HRS/LOAD",
      "WORKSHOP JOBS",
      "WORKSHOP HRS",
      "HRS/JOB",
      "FUEL LTRS",
      "KM COVERED",
      "KM/LTR",
      "MILEAGE COST",
      "TOTAL COST",
      "CPK",
    ]);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    // Add rows from the table
    rows.forEach((row) => {
      const rowData = [];
      row.querySelectorAll("td").forEach((cell) => {
        rowData.push(cell.textContent);
      });
      worksheet.addRow(rowData);
    });

    // Create a blob from the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Vehicles_KPI.xlsx";
      link.click();
    });
  };

  const PdfStockData = () => {
    const doc = new jsPDF();

    doc.text("Vehicles KPI - Report", 10, 10);

    const columns = [
      "S NO",
      "DRIVERNAME",
      "DEPARMENT",
      "MAKE",
      "VEHICLE",
      "GATE INS",
      "RETURNS",
      "W/B HRS",
      "ORDERS",
      "LOADING HRS",
      "HRS/LOAD",
      "WORKSHOP JOBS",
      "WORKSHOP HRS",
      "HRS/JOB",
      "FUEL LTRS",
      "KM COVERED",
      "KM/LTR",
      "MILEAGE COST",
      "TOTAL COST",
      "CPK",
    ];
    const data = filteredData.map((stock, index) => [
      index + 1,
      stock.DRIVERNAME,
      stock.DEPARMENT,
      stock.MAKE,
      stock.VEHICLE,
      stock?.["GATE INS"],
      stock.RETURNS,
      stock?.["W/B HRS"],
      stock.ORDERS,
      stock?.["LOADING HRS"],
      stock?.["HRS/LOAD"],
      stock?.["WORKSHOP JOBS"],
      stock?.["WORKSHOP HRS"],
      stock?.["HRS/JOB"],
      stock?.["FUEL LTRS"],
      stock?.["KM COVERED"],
      stock?.["KM/LTR"],
      stock?.["MILEAGE COST"],
      stock?.["TOTAL COST"],
      stock?.["CPK"],
    ]);

    doc.autoTable({
      head: [columns],
      body: data,
      startY: 20,
      showHead: "firstPage",
    });

    doc.save("Vehicles_KPI.pdf");
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen">
      <AllPagesNavbar />
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          VEHICLES KPI
        </h1>
        {/* <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        /> */}
      </div>

      <div className="flex gap-2 lg:mt-4 lg:ml-2">
        <p>Start Date :</p>
        <input
          type="date"
          className="w-32 h-8 lg:ml-12 lg:mr-2 border border-black rounded-md"
          value={startDate?.split("T")[0]}
          onChange={(e) => {
            setStartDate(e.target.value);
          }}
        ></input>
        <p className="lg:ml-32">End Date :</p>
        <input
          type="date"
          className="w-32 h-8 lg:ml-7 border border-black rounded-md"
          value={endDate?.split("T")[0]}
          onChange={(e) => {
            setEndDate(e.target.value);
          }}
        ></input>
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search :</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 lg:ml-16 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
        <div>
          <p className="lg:ml-2">Department :</p>
        </div>
        <div>
          <Select
            className="lg:w-64 w-64 lg:ml-2"
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, zIndex: 9999 }),
            }}
            value={
              selDepartment
                ? { value: selDepartment, label: selDepartment }
                : { value: "", label: "Select Department" }
            }
            onChange={(e) => {
              setSelDepartment(e.value);
            }}
            options={[
              { value: "", label: "Select Department" },
              ...departmentList?.map((item) => ({
                value: item,
                label: item,
              })),
            ]}
          ></Select>
        </div>
        <div>
          <p>Make :</p>
        </div>
        <div>
          <Select
            className="lg:w-64 w-64 lg:ml-2"
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, zIndex: 9999 }),
            }}
            value={
              selMake
                ? { value: selMake, label: selMake }
                : { value: "", label: "Select Make" }
            }
            onChange={(e) => {
              setSelMake(e.value);
            }}
            options={[
              { value: "", label: "Select Make" },
              ...makeList?.map((item) => ({
                value: item,
                label: item,
              })),
            ]}
          ></Select>
        </div>
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Sorting Criteria :</p>
        </div>
        <div>
          <Select
            className="lg:w-64 w-64 lg:ml-2"
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, zIndex: 9999 }),
            }}
            value={
              selSortBy
                ? { value: selSortBy, label: selSortBy }
                : { value: "", label: "Select Sorting Criteria" }
            }
            onChange={(e) => {
              setSelSortBy(e.value);
            }}
            options={[
              { value: "", label: "Select Sorting Criteria" },
              { value: "GATE INS", label: "GATE INS" },
              { value: "RETURNS", label: "RETURNS" },
              { value: "W/B HRS", label: "W/B HRS" },
              { value: "ORDERS", label: "ORDERS" },
              { value: "LOADING HRS", label: "LOADING HRS" },
              { value: "HRS/LOAD", label: "HRS/LOAD" },
              { value: "WORKSHOP JOBS", label: "WORKSHOP JOBS" },
              { value: "WORKSHOP HRS", label: "WORKSHOP HRS" },
              { value: "HRS/JOB", label: "HRS/JOB" },
              { value: "FUEL LTRS", label: "FUEL LTRS" },
              { value: "KM COVERED", label: "KM COVERED" },
              { value: "KM/LTR", label: "KM/LTR" },
              { value: "MILEAGE COST", label: "MILEAGE COST" },
              { value: "TOTAL COST", label: "TOTAL COST" },
              { value: "CPK", label: "CPK" },
            ]}
          ></Select>
        </div>
        <div>
          <p className="lg:ml-1">Order By :</p>
        </div>
        <div>
          <Select
            className="lg:w-64 w-64 lg:ml-8"
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, zIndex: 9999 }),
            }}
            value={
              selOrderBy
                ? { value: selOrderBy, label: selOrderBy }
                : { value: "", label: "Select Order By" }
            }
            onChange={(e) => {
              setSelOrderBy(e.value);
            }}
            options={[
              { value: "", label: "Select Order By" },
              { value: "ASCENDING", label: "ASCENDING" },
              { value: "DESCENDING", label: "DESCENDING" },
            ]}
          ></Select>
        </div>
      </div>
      <div className="visible lg:h-[380px] p-1 z-0 lg:overflow-auto mt-2">
        <div className="flex justify-end gap-2">
          <div className="cursor-pointer">
            <RiFileExcel2Line onClick={ExcelStockData} size={25} />
          </div>
          <div className="cursor-pointer">
            <BsFileEarmarkPdf onClick={PdfStockData} size={25} />
          </div>
        </div>
        <table className="w-full border border-gray-300 text-sm table_1 relative">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px] table-header">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
               <td className="py-2 px-4 text-left border border-gray-300">
                DRIVER NAME
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DEPARTMENT
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MAKE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                GATE INS
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                RETURNS
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                W/B HRS
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                ORDERS
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                LOADING HRS
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                HRS/LOAD
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                WORKSHOP JOBS
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                WORKSHOP HRS
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                HRS/JOB
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                FUEL LTRS
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                KM COVERED
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                KM/LTR
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MILEAGE COST
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TOTAL COST
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                CPK
              </td>
            </tr>
          </thead>
          <tbody>
            {sortedData?.map((value, index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 text-[13px]"
                // onClick={() => handleRowClick(value, index)}
              >
                <td className="py-2 px-4 text-right border border-gray-300">
                  {index + 1}
                </td>
                 <td className="py-2 px-4 text-left border border-gray-300">
                  {value.DRIVERNAME || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.DEPARMENT || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MAKE || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.VEHICLE || "N/A"}
                </td>
                <td className="py-2 px-4 text-right border border-gray-300">
                  {value?.["GATE INS"]
                    ? value?.["GATE INS"].toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0"}
                </td>
                <td className="py-2 px-4 text-right border border-gray-300">
                  {value?.["RETURNS"]
                    ? value?.["RETURNS"].toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0"}
                </td>
                <td className="py-2 px-4 text-right border border-gray-300">
                  {value?.["W/B HRS"]
                    ? value?.["W/B HRS"].toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0"}
                </td>
                <td className="py-2 px-4 text-right border border-gray-300">
                  {value?.["ORDERS"]
                    ? value?.["ORDERS"].toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0"}
                </td>
                <td className="py-2 px-4 text-right border border-gray-300">
                  {value?.["LOADING HRS"]
                    ? value?.["LOADING HRS"].toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0"}
                </td>
                <td className="py-2 px-4 text-right border border-gray-300">
                  {value?.["HRS/LOAD"]
                    ? value?.["HRS/LOAD"].toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0"}
                </td>
                <td className="py-2 px-4 text-right border border-gray-300">
                  {value?.["WORKSHOP JOBS"]
                    ? value?.["WORKSHOP JOBS"].toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0"}
                </td>
                <td className="py-2 px-4 text-right border border-gray-300">
                  {value?.["WORKSHOP HRS"]
                    ? value?.["WORKSHOP HRS"].toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0"}
                </td>
                <td className="py-2 px-4 text-right border border-gray-300">
                  {value?.["HRS/JOB"]
                    ? value?.["HRS/JOB"].toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0"}
                </td>
                <td className="py-2 px-4 text-right border border-gray-300">
                  {value?.["FUEL LTRS"]
                    ? value?.["FUEL LTRS"].toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0"}
                </td>
                <td className="py-2 px-4 text-right border border-gray-300">
                  {value?.["KM COVERED"]
                    ? value?.["KM COVERED"].toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0"}
                </td>
                <td className="py-2 px-4 text-right border border-gray-300">
                  {value?.["KM/LTR"]
                    ? value?.["KM/LTR"].toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0"}
                </td>
                <td className="py-2 px-4 text-right border border-gray-300">
                  {value?.["MILEAGE COST"]
                    ? value?.["MILEAGE COST"].toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0"}
                </td>
                <td className="py-2 px-4 text-right border border-gray-300">
                  {value?.["TOTAL COST"]
                    ? value?.["TOTAL COST"].toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0"}
                </td>
                <td className="py-2 px-4 text-right border border-gray-300">
                  {value?.["CPK"]
                    ? value?.["CPK"].toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0"}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot className="sticky bottom-[-12px] bg-white z-10">
            <tr className="font-semibold bg-gray-200 text-[13px]">
              <td className="py-2 px-4 border border-gray-300"></td>
              <td className="py-2 px-4 border border-gray-300"></td>
              <td className="py-2 px-4 border border-gray-300"></td>
              <td className="py-2 px-4 border border-gray-300"></td>
              <td className="py-2 px-4 border border-gray-300 text-right">
                Total :
              </td>

              <td className="py-2 px-4 text-right border border-gray-300">
                {totalGateIn?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || "0.00"}
              </td>

              <td className="py-2 px-4 text-right border border-gray-300">
                {totalReturn?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || "0.00"}
              </td>

              <td className="py-2 px-4 text-right border border-gray-300">
                {totalWbHr?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || "0.00"}
              </td>

              <td className="py-2 px-4 text-right border border-gray-300">
                {totalOrder?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || "0.00"}
              </td>

              <td className="py-2 px-4 text-right border border-gray-300">
                {totalLoadingHr?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || "0.00"}
              </td>

              <td className="py-2 px-4 text-right border border-gray-300">
                {totalHrsLoads?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || "0.00"}
              </td>

              <td className="py-2 px-4 text-right border border-gray-300">
                {totalWorkshopJobs?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || "0.00"}
              </td>

              <td className="py-2 px-4 text-right border border-gray-300">
                {totalWorkshopHrs?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || "0.00"}
              </td>

              <td className="py-2 px-4 text-right border border-gray-300">
                {totalHrsJob?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || "0.00"}
              </td>

              <td className="py-2 px-4 text-right border border-gray-300">
                {totalFuelLtrs?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || "0.00"}
              </td>

              <td className="py-2 px-4 text-right border border-gray-300">
                {totalKmCovered?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || "0.00"}
              </td>

              <td className="py-2 px-4 text-right border border-gray-300">
                {totalKmLtr?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || "0.00"}
              </td>

              <td className="py-2 px-4 text-right border border-gray-300">
                {totalMileageCost?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || "0.00"}
              </td>

              <td className="py-2 px-4 text-right border border-gray-300">
                {totalCost?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || "0.00"}
              </td>

              <td className="py-2 px-4 text-right border border-gray-300">
                {totalCPK?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || "0.00"}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default DriverKPI;
